import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/apple-pay': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8zM127.8 175.7c6.8 0.5 26.3 2.5 38.8 21.1-1 0.8-23.2 13.5-22.9 40.3 0.3 32 28 42.6 28.3 42.9-0.2 0.8-4.4 15.1-14.5 29.9-8.9 13-18 25.7-32.5 26-14 0.2-18.7-8.4-34.8-8.4-16 0-21.2 8.1-34.5 8.6-14 0.5-24.6-13.8-33.5-26.8-18.2-26.3-32.1-74-13.3-106.3 9.1-16.1 25.7-26.2 43.6-26.5 13.8-0.3 26.4 9.1 34.8 9.1 8.2 0 23.1-10.9 40.5-9.9zM228.2 139.5h73.2c37.7 0 64.1 26 64.1 64s-26.8 64.3-65.1 64.3h-41.9v66.6h-30.3v-194.9zM258.5 165v77.4h34.8c26.4 0 41.4-14.2 41.4-38.8 0-24.6-15-38.6-41.3-38.6h-34.9zM420.7 335.9c-28.1 0-47.7-16.8-47.8-42 0-25 19-39.4 54.1-41.5l37.8-2.3v-10.8c0-15.9-10.4-24.5-28.9-24.5-15.2 0-26.3 7.9-28.6 19.9h-27.3c0.9-25.2 24.7-43.6 56.8-43.6 34.6 0 57.1 18.2 57.1 46.3v97h-28v-23.4h-0.6c-8 15.3-25.6 24.9-44.6 24.9zM428.9 312.8c20.5 0 36-13 36-31.2v-11l-33.6 2.1c-18.9 1.1-28.8 8.2-28.8 20.5 0 11.8 10.3 19.6 26.4 19.6zM531.4 387.4c-2.3 0-9.8-0.3-11.6-0.7v-23.4c1.9 0.2 6.5 0.5 8.9 0.5 13.4 0 20.9-5.7 25.5-20.3l2.8-8.6-51.2-141.9h31.6l35.6 115.1h0.6l35.6-115.1h30.8l-53.1 149c-12.1 34.1-26 45.4-55.5 45.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/apple-pay.js
// module id = 713
// module chunks = 0